module.exports = __webpack_public_path__ + "img/app_bar.8ba6df63.png";